import {
    Button,
    Dialog,
    TextField,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
} from "@mui/material";
import {useState} from "react";
import axios_WES, {axios_Reports, axios_Identity} from "config/network";
import {useDispatch, useSelector} from "react-redux";
import {updateSessionTimeout} from "../redux/slices/authSlice";

export default function BaseURLDialog({open, handleClose}) {
    const [wes, setWes] = useState(process.env.REACT_APP_BASE_URL_API);
    const [identity, setIdentity] = useState(process.env.REACT_APP_BASE_URL_IDENTITY);
    const dispatch = useDispatch();
    const sessionTimeout = useSelector(state => state.auth.sessionTimeout);

    const handleChange = () => {
        axios_WES.defaults.baseURL = wes;
        axios_Reports.defaults.baseURL = wes;
        axios_Identity.defaults.baseURL = identity;
        handleClose();
    };

    const handleSessionTimeout = (value) => {
        dispatch(updateSessionTimeout(value));
    }
    return (
        <Dialog open={open} onClose={handleClose} fullWidth>
            <DialogTitle>Developers Only</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Change the baseURL to your local host
                </DialogContentText>
                <TextField
                    value={wes}
                    onChange={(e) => setWes(e?.target?.value)}
                    autoFocus
                    margin="dense"
                    id="baseUrl"
                    label="Base URL"
                    fullWidth
                />
                <TextField
                    value={identity}
                    onChange={(e) => setIdentity(e?.target?.value)}
                    autoFocus
                    margin="dense"
                    id="baseUrl"
                    label="Identity URL"
                    fullWidth
                />
                <TextField
                    value={sessionTimeout}
                    onChange={(e) => handleSessionTimeout(e?.target?.value)}
                    type={'number'}
                    autoFocus
                    margin="dense"
                    id="baseUrl"
                    label="User Session Timeout [Seconds]"
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleChange} variant="contained" color="primary">
                    Change
                </Button>
            </DialogActions>
        </Dialog>
    );
}
